import { useContext } from 'react';
import { ResponsiveContext } from '../../utils/responsive.es.js';

function useBreakpoint(size) {
  var state = useContext(ResponsiveContext);
  return !!state.breakpoints[size];
}

export { useBreakpoint };